import { FC } from 'react';

//components
import Links from './custom-link';

//styles
import styles from './stay-connected.module.scss';

//assets
import { locationLinks, socialMediaLinks } from 'Data/footer-assets';

const StayConnected: FC = () => {
  return (
    <div className={styles.stayConnectedContainer}>
      <div
        className={styles.locationLinksContainer}
        data-testid="location-links-container"
      >
        {locationLinks.map((link) => (
          <Links link={link} key={link.id} />
        ))}
      </div>
      <div
        className={styles.socialMediaContainer}
        data-testid="social-media-container"
      >
        {socialMediaLinks.map((link) => (
          <Links
            linkStyle={styles.socialMediaIcons}
            link={link}
            key={link.id}
          />
        ))}
      </div>
    </div>
  );
};

export default StayConnected;
